import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import './HomePage.css';

// Import des images
import heroBackground from '../images/fond.webp';

import teamviewerButton from '../images/teamviewer-button.png';

import depannageDistance from '../images/depannage-distance.webp';
import depannageDomicile from '../images/depannage-domicile-nantes.webp';
import ubuntu from '../images/ubuntu.jpg';
import profileImage from '../images/profile-expert.webp';
import browser from '../images/browser.webp';
import network from '../images/network.webp';
import formation from '../images/formation.webp';
import testimonial1 from '../images/testimonial-laetitia.png';
import testimonial2 from '../images/testimonial-jimmy.png';
import testimonial3 from '../images/testimonial-yann.png';

const HomePage = () => {
  return (
    <>
      <SEOHead 
        title="Excellence Informatique - Votre Spécialiste en Dépannage à Domicile"
        description="Dépannage informatique à domicile à Nantes et sa métropole. Réparation PC, ordinateur, assistance à distance. Contactez Excellence Informatique au 07 45 39 09 63"
        canonical="https://mon-depannage-informatique.fr/"
        keywords="dépannage informatique, réparation PC, ordinateur, domicile, Nantes, Loire-Atlantique, assistance à distance, Linux Ubuntu"
      />
      
      <div className="homepage">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-background">
            <img 
              src={heroBackground} 
              alt="Excellence Informatique - Environnement professionnel"
              className="hero-bg-image"
            />
          </div>
          
          <div className="container">
            <div className="hero-content">
              <h1 className="hero-title">EXCELLENCE INFORMATIQUE</h1>
              <p className="hero-subtitle">Votre solution <Link to="/blog/informaticien-expert-vs-amateur-notre-verdict-2025" className="blog-link"><strong>informatique experte</strong></Link> et personnalisée à domicile !</p>
              
              <div className="action-buttons">
                
                
                <a href="https://www.teamviewer.com/fr/telecharger/windows/" target="_blank" rel="noopener noreferrer" className="action-btn">
                  <img 
                    src={teamviewerButton} 
                    alt="Assistance à distance TeamViewer"
                    className="action-btn-img"
                  />
                </a>
                
                
              </div>
              
              
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section id="prestation" className="services-section">
          <div className="container">
            <h2 className="section-title">Nos prestations expertes en dépannage informatique à Nantes et sa métropole</h2>
            
            <div className="services-grid">
              <div className="service-card">
                <h3>Dépannage à Distance</h3>
                <img 
                  src={depannageDistance} 
                  alt="Excellence Informatique - Dépannage à distance professionnel"
                  className="service-image"
                />
                <p><Link to="/blog/informaticien-expert-vs-amateur-notre-verdict-2025" className="blog-link"><strong>Intervention rapide et sécurisée</strong></Link> pour résoudre vos problèmes informatiques sans vous déplacer.</p>
              </div>
              
              <div className="service-card">
                <h3>Dépannage à Domicile</h3>
                <img 
                  src={depannageDomicile} 
                  alt="Excellence Informatique - Intervention à domicile Nantes"
                  className="service-image"
                />
                <p>Déplacement chez vous pour une <Link to="/blog/informaticien-expert-vs-amateur-notre-verdict-2025" className="blog-link"><strong>prise en charge complète</strong></Link> de vos équipements informatiques.</p>
              </div>
              
              <div className="service-card">
                <h3>Systèmes Linux / Ubuntu</h3>
                <img 
                  src={ubuntu} 
                  alt="Excellence Informatique - Expertise Linux Ubuntu"
                  className="service-image"
                />
                <p>Installation, configuration et <Link to="/blog/4-types-maintenance-informatique-comparatif-expert" className="blog-link"><strong>maintenance</strong></Link> de systèmes Linux pour une alternative performante.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="contact-section">
          <div className="container">
            <h2 className="section-title">Contactez Excellence Informatique</h2>

            <div className="contact-content">
              <div className="profile-section">
                <img
                  src={profileImage}
                  alt="Expert Excellence Informatique"
                  className="profile-image"
                />
                <p className="contact-phone"><strong><Link to="/contact" style={{color: '#667eea', textDecoration: 'none'}}>Contactez-nous via notre formulaire</Link></strong></p>
              </div>

              <div className="services-details">
                <h3>Nos services spécialisés :</h3>
                <ul className="services-list">
                  <li>Nettoyage approfondi et complet de votre ordinateur</li>
                  <li>Réparation complète Windows, restauration de fichiers manquants</li>
                  <li>Optimisation avancée et nettoyage professionnel de Windows</li>
                  <li>Suppression définitive des virus et logiciels malveillants</li>
                  <li>Élimination des publicités intempestives</li>
                  <li>Résolution des problèmes de connexion internet</li>
                  <li>Configuration d'imprimantes et scanners</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Contacter Moi Section */}
        <section className="contact-cta-section">
          <div className="container">
            <div className="contact-cta-content">
              <h2>Besoin d'une assistance informatique ?</h2>
              <p>N'hésitez pas à nous contacter pour toute demande de dépannage, conseil ou devis gratuit. Notre équipe est à votre écoute pour résoudre tous vos problèmes informatiques rapidement et efficacement.</p>
              <div className="cta-buttons">
                <Link to="/contact" className="cta-btn primary">
                  📧 Formulaire de contact
                </Link>
                <Link to="/contact" className="cta-btn secondary">
                  💬 Contactez-nous
                </Link>
              </div>
              <p className="response-time">⚡ Réponse sous 24h garantie</p>
            </div>
          </div>
        </section>

        {/* Technical Services Section */}
        <section className="technical-services-section">
          <div className="container">
            <h2 className="section-title">Excellence Informatique - Services techniques avancés</h2>
            
            <div className="services-grid">
              <div className="service-card">
                <h3>Optimisation Navigateurs</h3>
                <img 
                  src={browser} 
                  alt="Excellence Informatique - Optimisation navigateur web"
                  className="service-image"
                />
                <p>Configuration et <Link to="/blog/4-types-maintenance-informatique-comparatif-expert" className="blog-link"><strong>optimisation</strong></Link> de vos navigateurs pour une navigation fluide et sécurisée.</p>
              </div>
              
              <div className="service-card">
                <h3>Configuration Réseau</h3>
                <img 
                  src={network} 
                  alt="Excellence Informatique - Configuration réseau professionnel"
                  className="service-image"
                />
                <p>Installation et configuration de votre réseau domestique ou professionnel.</p>
              </div>
              
              <div className="service-card">
                <h3>Formation Informatique</h3>
                <img 
                  src={formation} 
                  alt="Excellence Informatique - Formation personnalisée"
                  className="service-image"
                />
                <p>Cours particuliers adaptés à votre niveau pour maîtriser votre équipement informatique.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container">
            <h2 className="section-title">Témoignages clients Excellence Informatique</h2>
            
            <div className="testimonials-grid">
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <img 
                    src={testimonial1} 
                    alt="Laëtitia LAGADEC - Cliente satisfaite"
                    className="testimonial-avatar"
                  />
                  <div className="testimonial-info">
                    <strong>Laëtitia LAGADEC</strong>
                    <small>2022-11-23</small>
                  </div>
                </div>
                <p>"Excellent ! Un vrai professionnel, très compétent et efficace ! Je recommande vivement Excellence Informatique !"</p>
              </div>
              
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <img 
                    src={testimonial2} 
                    alt="Jimmy Lapleau - Client professionnel"
                    className="testimonial-avatar"
                  />
                  <div className="testimonial-info">
                    <strong>Jimmy Lapleau</strong>
                    <small>2022-11-23</small>
                  </div>
                </div>
                <p>"Pour une migration informatique complexe, Excellence Informatique a fait preuve d'un grand professionnalisme et d'une réactivité exemplaire. Services hautement recommandés !"</p>
              </div>
              
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <img 
                    src={testimonial3} 
                    alt="Yann Bazire - Client satisfait"
                    className="testimonial-avatar"
                  />
                  <div className="testimonial-info">
                    <strong>Yann Bazire</strong>
                    <small>2022-11-21</small>
                  </div>
                </div>
                <p>"Service rapide et de qualité exceptionnelle avec Excellence Informatique."</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HomePage;
